"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function TransitionOverlay(_a) {
    var topic = _a.topic, _b = _a.icon, icon = _b === void 0 ? "" : _b, children = _a.children;
    return (react_1.default.createElement("div", { className: "transition-overlay flex-grow-1 d-flex gap-2 justify-content-center align-items-center ".concat(topic === "default" ? "chat-overlay" : "") }, children ? (children) : (react_1.default.createElement(react_1.default.Fragment, null,
        icon !== "" && (react_1.default.createElement("svg", { className: "icon mb-0", width: "25", height: "25" },
            react_1.default.createElement("use", { href: "#".concat(icon) }))),
        react_1.default.createElement("span", { className: "gray" }, topic === "chats"
            ? window.Translator.trans("chat.loading_chats", {}, "js")
            : topic === "messages"
                ? window.Translator.trans("chat.loading_messages", {}, "js")
                : topic === "errorChats"
                    ? window.Translator.trans("chat.error_chats", {}, "js")
                    : topic === "default" && (react_1.default.createElement("svg", { className: "icon mb-0 gray", width: "100", height: "100" },
                        react_1.default.createElement("use", { href: "#messages" }))))))));
}
exports.default = TransitionOverlay;
